import { useEffect, useRef } from 'react';
import {
  acquireClassroomSocket,
  CLASSROOM_REALTIME_EVENTS,
  joinClassroomRoom,
  leaveClassroomRoom,
  releaseClassroomSocket,
} from '../services/classroomRealtime.service';

const useClassroomRealtime = (classroomId, handlers = {}) => {
  const handlersRef = useRef(handlers);

  useEffect(() => {
    handlersRef.current = handlers;
  }, [handlers]);

  useEffect(() => {
    if (!classroomId) return undefined;

    const socket = acquireClassroomSocket();
    if (!socket) return undefined;

    const onConnect = () => {
      joinClassroomRoom(socket, classroomId);
    };

    const listeners = Object.values(CLASSROOM_REALTIME_EVENTS).map((eventName) => {
      const listener = (payload) => {
        handlersRef.current?.[eventName]?.(payload);
      };
      socket.on(eventName, listener);
      return { eventName, listener };
    });

    socket.on('connect', onConnect);
    if (socket.connected) {
      onConnect();
    }

    return () => {
      leaveClassroomRoom(socket, classroomId);
      listeners.forEach(({ eventName, listener }) => {
        socket.off(eventName, listener);
      });
      socket.off('connect', onConnect);
      releaseClassroomSocket();
    };
  }, [classroomId]);
};

export default useClassroomRealtime;
